module.exports = __webpack_public_path__ + "static/media/rsz_lunch-2.dc28eec4.jpg";